import { Injectable, inject } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

const PROJECT_PK = 'projectPk';
const STEP = 'step';

@Injectable({
  providedIn: 'root'
})
export class ProjectDeepLinkService {

  private readonly router = inject(Router);
  private readonly location = inject(Location);

  buildLink(route: string, projectPk: number, step: number): string {
    return `${environment.redirectUri}#/${route}?${PROJECT_PK}=${projectPk}&${STEP}=${step}`;
  }

  get projectPk(): number | undefined {
    return this.queryParam(PROJECT_PK);
  }

  get step(): number | undefined {
    return this.queryParam(STEP);
  }

  clear(): void {
    this.location.replaceState(this.router.url.split('?')[0], '', this.location.getState());
  }

  private queryParam(name: string): number | undefined {
    const value = Number(this.router.routerState.snapshot.root.queryParamMap.get(name));
    return Number.isFinite(value) && value > 0 ? value : undefined;
  }
}
